import { expensesRoutes } from "./expensesRoutes";
import { delegationRoutes } from "./delegationRoutes";
import { teamsRoutes } from "./teamsRoutes";
import { employeeFolderRoutes } from "./employeeFolderRoutes";
import { timeReportingRoutes } from "./timeReportingRoutes";
import { remoteJobRoutes } from "./remoteJobRoutes";
import { addEmployeeRoutes } from "./addEmployeeRoutes";
import { prepareOffboardingRoutes } from "./prepareOffboardingRoutes";
import { auth2faRoutes } from "./auth2faRoutes";
import { annuaireRoutes } from "./annuaireRoutes";
import { tasksRoutes } from "./tasksRoutes";
import { detailDocumentRoutes } from "./detailDocumentRoutes";
import { dashboardRoutes } from "./dashboardRoutes";
import { documentsHrRoutes } from "./documentsHrRoutes";
import { preonboardingRoutes } from "./preonboardingRoutes";
import { leaveRoutes } from "./leaveRoutes";
import { onBoardingRoutes } from "./onboardingRoutes";
import { offboardingRoutes } from "./offboardingRoutes";
import { authRoutes } from "./authRoutes";
import { approvalsRoutes } from "./approvalsRoutes";
import { errorsRoutes } from "./errorsRoutes";
import { collaboratorFactsheetRoutes } from "./collaboratorFactsheetRoutes";
import { pilotageRhRoutes } from "./pilotageRhRoutes";

export const appRoutes = [
    expensesRoutes,
    delegationRoutes,
    teamsRoutes,
    employeeFolderRoutes,
    timeReportingRoutes,
    remoteJobRoutes,
    addEmployeeRoutes,
    prepareOffboardingRoutes,
    auth2faRoutes,
    annuaireRoutes,
    tasksRoutes,
    dashboardRoutes,
    detailDocumentRoutes,
    documentsHrRoutes,
    preonboardingRoutes,
    leaveRoutes,
    onBoardingRoutes,
    offboardingRoutes,
    authRoutes,
    approvalsRoutes,
    errorsRoutes,
    collaboratorFactsheetRoutes,
    pilotageRhRoutes,
];
